import { isBrowser } from "@citrine/configuration";

const REFRESH_BUFFER_MS = 30_000;
const FALLBACK_LIFETIME_MS = 300_000;

/**
 * Refresh just before the access token expires, so a burst of requests after an
 * idle stretch does not all fail and retry. Fall back to a five-minute lifetime
 * when the token cannot be decoded.
 */
export function refreshDelayMs(accessToken: string, now = Date.now()): number {
  const expiresAt = jwtExpiryMs(accessToken);
  const lifetime =
    expiresAt === undefined ? FALLBACK_LIFETIME_MS : expiresAt - now;
  return Math.max(lifetime - REFRESH_BUFFER_MS, 0);
}

function jwtExpiryMs(token: string): number | undefined {
  const payload = token.split(".")[1];
  if (!payload) {
    return undefined;
  }

  try {
    const json = isBrowser
      ? window.atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
      : Buffer.from(payload, "base64url").toString();
    const claims = JSON.parse(json) as { exp?: unknown };
    return typeof claims.exp === "number" ? claims.exp * 1000 : undefined;
  } catch {
    return undefined;
  }
}
